import '@components/Search.scss';
import { useEffect, useRef, useState } from 'react';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SearchSelect from './SearchSelect';
import { useTenant } from '@providers/TenantProvider';
import { communityUrl } from 'api';
import { Autocomplete, AutocompleteOption, ListItemContent, ListItemDecorator, Typography, createFilterOptions } from '@mui/joy';
import { useAuth } from '@providers/AuthProvider';
import { matchSorter } from 'match-sorter';

const filter = createFilterOptions();
const filterOptions = (options, { inputValue }) => matchSorter(options, inputValue);

export default function CommunityJumper() {
    const { user } = useAuth();
    const { tenant } = useTenant();

    // only display for users who have access to multiple installs
    if(!user?.installs) {
        return null;
    }

    return (<>
        <SearchSelect
            size="sm"
            disableClearable
            // freeSolo
            endpoint="installs"
            // options={user?.installs ?? []}
            loadAll={true}
            hydrateWith={user?.installs ?? []}
            onChange={(id, community) => {
                // window.location = communityUrl.replace('%subdomain%', community.subdomain);
            }}
            value={tenant?.id}
            filterOptions={(options, params) => {
                const {inputValue} = params;

                // search all keys
                const filtered = options.filter(option => {
                    return (
                        option.name.toLowerCase().includes(inputValue.toLowerCase())
                        || option.subdomain.toLowerCase().includes(inputValue.toLowerCase())
                        || (option?.city ?? '').toLowerCase().includes(inputValue.toLowerCase())
                        || (option?.state ?? '').toLowerCase().includes(inputValue.toLowerCase())
                    );
                });

                return filtered;
            }}
            startDecorator={<ExploreOutlinedIcon color="primary"/>}
            sx={{
                maxWidth: '200px',
                '--joy-zIndex-modal': 'calc(var(--joy-zIndex-popup) + 10)'
            }}
            renderOption={(props, option) => (
                <AutocompleteOption {...props} component={'a'} href={communityUrl.replace('%subdomain%', option.subdomain)}>
                    <ListItemContent sx={{ fontSize: 'sm' }}>
                    {option.name}
                    <Typography level="body-xs">
                        {option.city}, {option.state}
                    </Typography>
                    </ListItemContent>
                </AutocompleteOption>
            )}
        />
    </>);
}

